module.exports = __webpack_public_path__ + "img/icon-warning-snøskred-2.3948a4f2.svg";